"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _priceFormat = _interopRequireDefault(require("@deosite/helpers/priceFormat"));
var _CurrencyProvider = require("../REST/CurrencyProvider");
function usePriceFormatter() {
  var _useCurrency = (0, _CurrencyProvider.useCurrency)(),
    currency = _useCurrency.currency;
  var currencySymbol = currency === null || currency === void 0 ? void 0 : currency.symbol;
  return {
    currencySymbol: currencySymbol,
    priceWithSymbol: function priceWithSymbol(price) {
      return (0, _priceFormat["default"])(price) + " " + currencySymbol;
    }
  };
}
var _default = usePriceFormatter;
exports["default"] = _default;